export enum ChatBroadcastType {
	ChatEvent = 0,
	AllMessages = 1,
	UserList = 2,
	RoomEvent = 3,
}

export enum ChatUserType {
	User = 0,
	Moderator = 1,
	Admin = 2,
}

export type ChatBroadcastWrapper = {
	BroadcastType: ChatBroadcastType;
	RoomId?: number;
	Data: unknown;
};

export type ChatRoomEvent = {
	EventType: ChatSignalREventType;
	ChatRoomId: number;
};

export type ChatMessage = {
	Id: number;
	FromUserId: number;
	FromUserAlias: string;
	FromUserPhoto: string;
	FromUserAvatar: string;
	FromUserType: number;
	Message: string;
	SentDateUTC: Date;
	ChatRoomId: number;
	LinkedObjectType?: number;
	LinkedObjectId?: number;
	EventType?: ChatSignalREventType;
};

export enum ChatSignalREventType {
	MessageToRoom = 0,
	JoinRoom = 1,
	LeaveRoom = 2,
	UserEvent = 3,
	UserJoined = 4,
	UserLeft = 5,
	UserMuted = 6,
	UserUnmuted = 7,
	UserBanned = 8,
	UserUnbanned = 9,
	RoomClosed = 10,
	RoomOpened = 11,
	MessagesDelivered = 12,
}

export type ChatUser = {
	UserId: number;
	UserName: string;
	UserDisplayName: string;
	UserPhoto: string | null;
	//Avatar: string;
	Role: number; // 0=User, 1=Moderator, 2=Admin
	IsOnline: boolean;
	IsInRoom: boolean;
};

export type SignalRChatMessage = {
	ClientMessageType: 'MessageToRoom' | 'JoinRoom' | 'LeaveRoom' | 'SetTopic' | 'UserEvent';
	RoomName: string;
	Message: string;
	UserId?: number;
	EventType?: number;
};

export type SignalRServerMessage = {
	HubServerName: 'HubChat';
	PortalId: number;
	Content: string; // JSON string of SignalRChatMessage
};
